<template>
    <div ref="ppEl">
        <div
            id="pp-component"
            loginFrom="Sports"
            v-bind:isAsi="isAsi"
        />
    </div>
</template>

<script lang="ts">
    import { apmBase } from '@elastic/apm-rum';
    import axios from 'axios';
    import { storeToRefs } from 'pinia';
    import { defineComponent, onMounted, ref, watch } from 'vue';
    import { createApiInstance } from '@/libraries/apis/createApiInstance';
    import { getPpUrl } from '@/libraries/url';
    import { loadCss, loadScript } from '@/libraries/utils/dom';
    import { useHeaderDisplayStore } from '@/stores/headerDisplayStore';
    import { useRootStore } from '@/stores/rootStore';

    const ppResourceInstance = createApiInstance({ timeout: 15 * 1000 });

    export default defineComponent({
        setup() {
            const ppEl = ref<HTMLElement | null>(null);

            const { isAsi } = storeToRefs(useRootStore());
            const { ppTop, ppTranslateY } = storeToRefs(useHeaderDisplayStore());

            async function loadResources() {
                const ppUrl = getPpUrl();
                const fileName = 'pp';

                try {
                    const response = await ppResourceInstance.get<string[]>(`${ppUrl}/resources.json`);
                    const filePaths = response.data.filter(x => x.includes(`/${fileName}.`) || x.includes('chunk'));
                    filePaths.forEach((filePath) => {
                        if (filePath.endsWith('.js')) {
                            loadScript(`${ppUrl}${filePath}`);
                        }
                        if (filePath.endsWith('.css')) {
                            loadCss(`${ppUrl}${filePath}`);
                        }
                    });
                } catch (error) {
                    // The axios interceptor already reported failures that got a response; report the rest (e.g. network errors).
                    if (error instanceof Error && !(axios.isAxiosError(error) && error.response)) {
                        apmBase.captureError(error);
                    }
                }
            }

            function updatePpStyle() {
                const sboMenu = ppEl.value?.querySelector('.sboMenu-header') as HTMLElement | null;
                if (!sboMenu) return;

                sboMenu.style.transition = '.5s';
                sboMenu.style.top = `${ppTop.value}px`;
                sboMenu.style.transform = `translateY(${ppTranslateY.value}px)`;
            }

            onMounted(() => {
                updatePpStyle();
                loadResources();
            });

            watch([ppTop, ppTranslateY], () => {
                updatePpStyle();
            });

            return {
                ppEl,
                isAsi,
                ppTop,
            };
        },
    });
</script>
